import {
    Button,
    FormControl,
    FormHelperText,
    InputLabel,
    MenuItem,
    Select,
} from '@material-ui/core';
import TextInput from '../../lib/TextField';
import en from '../../lang/en-us';
import { useState } from 'react';
import { SubmitButton } from '../../lib/Button';
import { connect } from 'react-redux';
import { giveFeedback } from '../../redux-store/actions/nct';
import { emailRegex } from '../../utils/constants';
const { myProfile, common } = en;

type feedbackProps = {
    getDetails: Function;
    isSubmitting: boolean;
};

function GiveFeedbackUI({ getDetails = () => { }, isSubmitting = false }: feedbackProps) {
    const [state, setState] = useState({
        userName: '',
        userEmailId: '',
        queryType: '',
        queryReferenceId: '',
        query: '',
    });

    const [errors, setErrors] = useState<any>({});

    const handleChange = (key: string, value: string) => {
        setState({
            ...state,
            [key]: value,
        });
    };

    const validateForm = () => {
        let errors: any = {};
        let isValidForm: any = {};
        const { userName, userEmailId, queryType, query, queryReferenceId } = state;
        if (!userName) {
            errors['userName'] = 'Please enter username';
            isValidForm = false;
        }
        if (!userEmailId) {
            errors['userEmailId'] = 'Please enter email id';
            isValidForm = false;
        } else if (userEmailId && !emailRegex.test(userEmailId)) {
            errors['userEmailId'] = common.errors.email.regex;
            isValidForm = false;
        }
        if (!queryType) {
            errors['queryType'] = 'Please select query type';
            isValidForm = false;
        }
        if (queryType === 'submitted' && !queryReferenceId) {
            errors['queryReferenceId'] = 'please enter query reference id';
            isValidForm = false;
        }
        if (!query) {
            errors['query'] = 'Please enter your query';
            isValidForm = false;
        }
        setErrors(errors);
        return isValidForm;
    };

    const handleSubmit = () => {
        if (validateForm()) {
            getDetails(state);
        }
    };

    const resetFieldError = (fieldName: string) => {
        const { [fieldName]: excldeKey, ...rest } = errors;
        setErrors(rest);
    };

    return (
        <div className="give-feedback">
            {/* Screen reader announcements for validation errors */}
            <div
                role="alert"
                aria-live="assertive"
                aria-atomic="true"
                className="sr-only"
                style={{ position: 'absolute', left: '-9999px', width: '1px', height: '1px', overflow: 'hidden' }}
            >
                {Object.values(errors).length > 0 && Object.values(errors).join('. ')}
            </div>
            <TextInput
                id="feedback-name"
                label={myProfile.enterName}
                variant="outlined"
                name={'userName'}
                value={state.userName}
                onChange={({ target: { value } }) => {
                    resetFieldError('userName');
                    handleChange('userName', value);
                }}
                error={!!errors['userName']}
                helperText={errors['userName']}
                aria-invalid={!!errors['userName']}
                aria-describedby={errors['userName'] ? 'feedback-name-helper-text' : undefined}
            />
            <TextInput
                id="feedback-email"
                label={myProfile.enterEmail}
                variant="outlined"
                name={'userEmailId'}
                value={state.userEmailId}
                onChange={({ target: { value } }) => {
                    resetFieldError('userEmailId');
                    handleChange('userEmailId', value);
                }}
                error={!!errors['userEmailId']}
                helperText={errors['userEmailId']}
                aria-invalid={!!errors['userEmailId']}
                aria-describedby={errors['userEmailId'] ? 'feedback-email-helper-text' : undefined}
            />
            <FormControl variant="outlined" error={!!errors['queryType']}>
                <InputLabel id="query-type-label">{myProfile.enterServiceName}</InputLabel>
                <Select
                    labelId="query-type-label"
                    id="query-type"
                    value={state.queryType}
                    onChange={({ target: { value } }) => {
                        resetFieldError('queryType');
                        handleChange('queryType', value as string);
                    }}
                    aria-invalid={!!errors['queryType']}
                    aria-describedby={errors['queryType'] ? 'query-type-helper-text' : undefined}
                >
                    <MenuItem value="registration">Registration</MenuItem>
                    <MenuItem value="login">Login</MenuItem>
                    <MenuItem value="submitted">Submitted Request</MenuItem>
                    <MenuItem value="feedback">Feedback</MenuItem>
                </Select>
                <FormHelperText id="query-type-helper-text">{errors['queryType']}</FormHelperText>
            </FormControl>
            {state.queryType === 'submitted' && (
                <TextInput
                    id="feedback-refId"
                    label={myProfile.enterRefId}
                    variant="outlined"
                    name={'referenceId'}
                    error={!!errors['queryReferenceId']}
                    helperText={errors['queryReferenceId']}
                    value={state.queryReferenceId}
                    onChange={({ target: { value } }) => {
                        resetFieldError('queryReferenceId');
                        /^\d+$/.test(value) || !value
                            ? handleChange('queryReferenceId', value)
                            : null;
                    }}
                    aria-invalid={!!errors['queryReferenceId']}
                    aria-describedby={errors['queryReferenceId'] ? 'feedback-refId-helper-text' : undefined}
                />
            )}
            <TextInput
                id="register-complaint-input"
                multiline
                label={myProfile.enterQuery}
                rows={7}
                variant="outlined"
                name={'query'}
                value={state.query}
                onChange={({ target: { value } }) => {
                    resetFieldError('query');
                    value.length < 501 ? handleChange('query', value) : null;
                }}
                error={!!errors['query']}
                helperText={errors['query']}
                aria-invalid={!!errors['query']}
                aria-describedby={errors['query'] ? 'register-complaint-input-helper-text' : undefined}
            />
            {isSubmitting ? (
                <Button fullWidth className="customBtn">
                    Submitting
                    <span className="sending-dots">
                        <i></i>
                        <i></i>
                        <i></i>
                    </span>
                </Button>
            ) : (
                <SubmitButton type="submit" label={myProfile.submit} onClick={handleSubmit} />
            )}
        </div>
    );
}

export default connect(null, { giveFeedback })(GiveFeedbackUI);
